import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config.service.service';

@Injectable({
  providedIn: 'root'
})
export class TaskService {

  private uri = "";// `${environment.apiUrl}`;

  constructor(private http: HttpClient, private appConfigService: AppConfigService) {
    this.uri = this.appConfigService.apiBaseUrl;
  }

  getParamethers(service){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'GetProcedureXMLParameters', procedurename: 'SP_API_Flex_'+service  });
  }

  GetTaskUrl() {
    return this.uri + '/Task';
  }

  GeneralService(obj) {
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  GetSummaryTask(projectid) {
    // return this.http.post<any>(this.uri + '/SummaryTask', { id: projectid });
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_SummaryTaskByProject', projectid:projectid });
  }

  DeleteSummaryTask(id) {
    return this.http.post<any>(this.uri + '/SummaryTask/DeleteSummaryTask', { summarytaskid: id });
  }



  UpdateSummaryTask(model) {
    return this.http.post<any>(this.uri + '/SummaryTask/InsertUpdateSummaryTask', model);
  }




  GetTaskAll(date){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_Task_All', tsdate:date });
  }

  GetTaskAll2(param, method){
    param['method'] = method;
    return this.http.post<any>(this.uri + '/FlexIntegration', param);
  }

  GetTaskPaginate(filters){
    return this.http.post<any>(this.uri + '/FlexIntegration', filters);
  }

  Get_Task_PagedDiagram(filters){
    return this.http.post<any>(this.uri + '/FlexIntegration', filters);
  }

  GetSwoAll(date){
    console.log({ method: 'Get_SWO_ServiceListAll', tsdate:date });
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_SWO_ServiceListAll', tsdate:date });
  }

  GetSwoFilter(form){
    console.log(form);
    return this.http.post<any>(this.uri + '/FlexIntegration', form);
  }

  GetPagedTasksUrl() {
    return this.uri + '/Task/GetTasks';
  }

  GetTasks(filter: any) {
    return this.http.post<any>(this.uri + '/Task/GetTasksForManagment', filter);
  }
 
  NotificationTask(data){
    return this.http.post<any>(this.uri + '/Notifications/NotificationTask', data);
  }

  Get_TaskInfo(obj){
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }
 
  DeleteTaskForEmployee(projecttodoid: number, resourceid: number) {
    return this.http.post<any>(this.uri + '/Task/DeleteResourceFromTask', { projecttodoid: projecttodoid, resourceid: resourceid });
  }

  UpdateTaskResourceDates(projecttodoid: string, startdate: string, estimatedtime: string) {
    return this.http.post<any>(this.uri + '/Task/UpdateTaskResourceDates', { taskid: projecttodoid, startdate: startdate, estimatedtime: estimatedtime });
  }

  GetProjectByName(projectname: string) {
    return this.http.post<any>(this.uri + '/Project/GetProjectByName', { projectname: projectname });
  }

  GetTaskCategories() {
    // console.log('Task Categories ');
    return this.http.post<any>(this.uri + '/TaskCategory', {});
  }

  GetTaskCategoriesFlex() {
    // console.log('Task Categories ');
    // return this.http.post<any>(this.uri + '/TaskCategory', {});
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_TaskCategory' });
  }

  //--------------------------------------
  Activetaskcategory(){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_TaskCategoryCE_Active' });
  }

  ChangeActiveTaskCategory(obj){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'SaveTaskCategories' });
  }

  GetTaskStatus() {
    return this.http.post<any>(this.uri + '/TaskStatus', {});
  }

  GetTaskPriorities() {
    return this.http.post<any>(this.uri + '/TaskPriority', {});
  }

  GetTaskEmployees() {
    // return this.http.post<any>(this.uri + '/Employee', {});
    // console.log('Call Employee ')
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_EmployeeListAll' });
  }

  GetTaskPhases() {
    return this.http.post<any>(this.uri + '/TaskPhase', {});
  }

  GetTaskLocation() {
    return this.http.post<any>(this.uri + '/TaskLocation', {});
  }

  GetPagedTasks(taskFilter: any) {
    return this.http.post<any>(this.uri + '/Task/GetTasks', taskFilter);
  }

  GetPagedTaskFlex(taskFilter: any) {
    console.log(taskFilter)
    return this.http.post<any>(this.uri + '/FlexIntegration', taskFilter);
  }

  UpdateSummaryTaskGantt(taskid, summarytaskid){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'UpdateSummaryTask', taskid: taskid, summarytaskid: summarytaskid });
  }

  DuplicateTask(id) {
    return this.http.post<any>(this.uri + '/Task/DuplicateTask', {taskid: id});
  }

  GetTaskGanttData(filterGantt) {
    return this.http.post<any>(this.uri + '/Task/GetTaskGanttData', { summaryvalues: filterGantt.summaryvalues, startdate: this.formatDate(filterGantt.startdate), enddate: this.formatDate(filterGantt.enddate) });
  }

  GetForGanttView(summaryvalues,startdate, enddate, method, projectid){
    let obj = {
      method: method,
      summaryvalues: summaryvalues,
      startdate: startdate,
      enddate: enddate,
      projectid: projectid
    }
    console.log(obj);
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  GetForGanttViewPaged(summaryvalues,startdate, enddate, method, projectid, pageindex, pagesize){
    let obj = {
      method: method,
      summaryvalues: summaryvalues,
      startdate: startdate,
      enddate: enddate,
      projectid: projectid,
      pageindex: pageindex,
      pagesize: pagesize
    }
    console.log(obj);
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  GetForGanttPagedByTaskIds(projectid, method, taskids){
    let obj = {
      method: method,
      projectid: projectid,
      taskids: taskids 
    }
    console.log(obj);
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  GetResourcesForGanttPaged(projectid, employeeids){
    let obj = {
      method: 'Get_TaskResourcesForGanttCE_ByEmployeeIDs',
      projectid: projectid,
      employeeids: employeeids 
    }
    console.log(obj);
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  GetTimeSheetsByTask(id) {
    return this.http.post<any>(this.uri + '/Timesheet/GetTimeSheetsByTask', { taskid: id });
  }

  DeleteTimeSheet(id) {
    return this.http.post<any>(this.uri + '/Timesheet/DeleteTimeSheet', { timesheetid: id });
  }

  InsertUpdateTimesheet(model) {
    console.log(model);
    return this.http.post<any>(this.uri + '/Timesheet/InsertUpdateTimesheet', model);
  }

  GetTasksDependencies(id) {
    return this.http.post<any>(this.uri + '/TaskDependency/GetTaskTasksDependencies', { taskid: id });
  }

  InsertUpdateTaskDependency(model) {
    console.log('Guardé dependency ', model)
    return this.http.post<any>(this.uri + '/TaskDependency/InsertUpdateTaskDependency', model);
  }

  DeleteDependecy(id) {
    return this.http.post<any>(this.uri + '/TaskDependency/DeleteTaskTasksDependencies', { id: id });
  }

  DeleteDependencyGantt(fromTaskid, toTaskid){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Delete_Task_ProjectTodoDependencies', fromtaskid: fromTaskid,  totaskid: toTaskid});
  }

  GetDependendecyType() {
    return this.http.post<any>(this.uri + '/TaskDependencyType', {});
  }

  GetTasksByProjectId(id, statuses?){
    let status = statuses== null ? null : statuses;
    console.log({method:'Get_Task_AllByProjectId', numProjectID:id, statuses: status});
    return this.http.post<any>(this.uri + '/FlexIntegration', {method:'Get_Task_AllByProjectId', numProjectID:id, statuses: status});
  }

  GetTasksByProjectIdNoStatus(id){
    return this.http.post<any>(this.uri + '/FlexIntegration', {method:'Get_Task_AllByProjectId', numProjectID:id});
  }

  GetTaskById(id){
    return this.http.post<any>(this.uri + '/FlexIntegration', {method:'Get_Task_ByTaskId ', id:id});
  }

  GetSubContractors(projectid) {
    return this.http.post<any>(this.uri + '/SubContractors/GetSubcontractorByProject', {projectid: projectid});
  }
  formatDate(theDate) {
    var date = theDate;
    var aaaa = date.getFullYear();
    var gg = date.getDate(); 
    var mm = (date.getMonth() + 1);

    if (gg < 10)
      gg = "0" + gg;

    if (mm < 10)
      mm = "0" + mm;

    var cur_day = aaaa + "-" + mm + "-" + gg;

    var hours = date.getHours()
    var minutes = date.getMinutes()
    var seconds = date.getSeconds();

    if (hours < 10)
      hours = "0" + hours;

    if (minutes < 10)
      minutes = "0" + minutes;

    if (seconds < 10)
      seconds = "0" + seconds;

    return cur_day + " " + hours + ":" + minutes + ":" + seconds;

  }

  updateTask(formTask: any) {
    return this.http.post<any>(this.uri + '/Task/InsertUpdateTask',
      {
        id: 0,
        name: formTask.name,
        projectid: formTask.projectid,
        employeeid: formTask.responsibleid,
        resources: formTask.resources,
        statusid: formTask.statusid,
        todocategoryid: formTask.categoryid,
        priorityid: formTask.taskpriorityid,
        startdate: this.formatDate(formTask.taskstartdate),
        estimatedtime: formTask.taskduration,
        completionperc: formTask.taskcompletition,
        duedate: this.formatDate(formTask.taskduedate),
        completiondate: this.formatDate(formTask.taskcompletiondate)
      });
  }

  updateTask2(formTask: any) {
    return this.http.post<any>(this.uri + '/FlexIntegration', formTask);
  }

  GetTaskHoursByResource(employeeid, datetime){
    console.log({method: 'Get_TaskHours_ByResource_ByDay', employeeid: employeeid, datetime: datetime })
    return this.http.post<any>(this.uri + '/FlexIntegration', {method: 'Get_TaskHours_ByResource_ByDay', employeeid: employeeid, datetime: datetime });
  }
 
  updateDueDateTwoWeek(id){
    return this.http.post<any>(this.uri + '/FlexIntegration', {method: 'UpdateProjectToDoEndDate', projecttodoid: id});
  }

  DeleteTask(id){
    return this.http.post<any>(this.uri + '/FlexIntegration', {method: 'Delete_TaskCE', id: id });
  }

  DuplicateTaskGrid(id){
    return this.http.post<any>(this.uri + '/FlexIntegration', {method: 'Duplicate_Task', projecttodoid: id });
  }

  Get_CalendarTaks(date, identifier, employeeid ?, resources ?, statusid ?, reponsibleid ?, categoryid ?, projectid ?){
    let obj: any = {
      method: 'Get_MasterSchedule',
      itemdate: date,
      todoidentifier: identifier,
      resources: resources,
    }
    employeeid ? obj.employeeid = employeeid : '';
    resources ? obj.resources = resources : '';
    statusid ? obj.statusid = statusid : '';
    reponsibleid ? obj.reponsibleid = reponsibleid : '';
    categoryid ? obj.categoryid = categoryid : '';
    projectid ? obj.projectid = projectid : '';

    console.log(obj)
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }  

  Update_TaskDate(id, startDate, estimatedtime, progress, endDate){
    console.log({
      method: 'Update_TaskDate',
      projecttodoid: id,
      startdate: startDate,
      estimatedtime: estimatedtime,
      completitionperc: progress,
      duedate: endDate
    })
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Update_TaskDate',
      projecttodoid: id,
      startdate: startDate,
      estimatedtime: estimatedtime,
      completitionperc: progress,
      duedate: endDate
    });
  }

  Update_TaskCalendar(id, startDate, estimatedtime, progress, resourceids){
    let obj = {
      method: 'Update_TaskCalendar',
      projecttodoid: id,
      startdate: startDate,
      estimatedtime: estimatedtime,
      completitionperc: progress,
      resoruceids: resourceids
    }
    console.log(obj);
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  Update_TaskDependency(hours, taskid){
    let obj = { method: 'PROJECTTODOShiftSuccessor',dateshift:hours, projecttodoid: taskid }
    console.log(obj);
    return this.http.post<any>(this.uri+ '/FlexIntegration', obj);
  }

  Update_ServiceStartTime(id, startDate, endtime){
    let obj = {
      method: 'Update_ServiceStartTime',
      serviceid: id,
      starttime: startDate,
      endtime: endtime
    }
    // console.log(obj)
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  Update_ServiceStartTime2(id, startDate, endtime, oldresourceid, newresourceid){
    let obj = {
      method: 'Update_ServiceStartTime',
      serviceid: id,
      starttime: startDate,
      endtime: endtime,
      oldresourceid: oldresourceid,
      newresourceid: newresourceid
    }
    console.log(obj)
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  GetResourcesForGantt(startdate,days, ProjectIds, ResourceIds,CategoryIds){
    let obj = {
      method: 'Get_TasksCE',
      startdate: startdate,
      numberofdays: days,
      projectids: ProjectIds,
      resourceids: ResourceIds,
      categoryids: CategoryIds
    }
    console.log(obj)
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  GetResourcesForDispatch(startdate,days, ProjectIds, ResourceIds,CategoryIds){
    let obj = {
      method: 'Get_TasksCEDispatchBoard',
      startdate: startdate,
      numberofdays: days,
      projectids: ProjectIds,
      resourceids: ResourceIds,
      categoryids: CategoryIds
    }
    console.log(obj)
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  GetTodoAll(id){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectTodoAll', moduleid: id })
  }

  GetServicesAll(id){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ServicesAll', moduleid: id })
  }

  //Memorize Task
  Get_ProjectTodoSummaryMemorized(id){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectTodoSummaryMemorized', projectid: id })
  }

  Get_ProjectTodoMemorized(id){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectTodoMemorized', projectid: id })
  }

  Insert_Upadte_MemorizeTaskCE(obj){
    return this.http.post<any>(this.uri + '/FlexIntegration', obj)
  }

  Insert_ProjectTodoSummaryMemorizedCE(obj){
    return this.http.post<any>(this.uri + '/FlexIntegration', obj)
  }

  // GeneralService(obj){
  //   return this.http.post<any>(this.uri + '/FlexIntegration', obj)
  // }
}
